import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Radio } from '@3plearning/react-components';
import {
    SELECTION_AS_IS,
    FIRST_VS_LATEST,
    FIRST_VS_HIGHEST,
    HIGHEST_VS_LATEST
} from '../../containers/participation/student/student-constants';
import css from './improvement-type-picker.scss';
import { improvementTypeTranslations } from './improvement-type-translations';

/**
 * Component to pick the improvement calculation type to use when exporting student
 * participation report
 */
class ImprovementTypePicker extends Component {
    static propTypes = {
        initialSelection: PropTypes.string,
        pickImprovementType: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        const {
            AsIs,
            FirstHighest,
            FirstLatest,
            HighestLatest
        } = improvementTypeTranslations();
        this.improvements = [
            {
                label: AsIs,
                value: SELECTION_AS_IS
            },
            {
                label: FirstHighest,
                value: FIRST_VS_LATEST
            },
            {
                label: FirstLatest,
                value: HIGHEST_VS_LATEST
            },
            {
                label: HighestLatest,
                value: FIRST_VS_HIGHEST
            }
        ];

        this.state = {
            selected: props.initialSelection
        };
    }

    selectOption = (value) => {
        this.setState({
            selected: value
        });
        this.props.pickImprovementType(value);
    };

    render() {
        const { selected } = this.state;

        return (
            <div className={css.component}>
                <div className={css['option-container']}>
                    {this.improvements.map((improvement) => (
                        <Radio
                            key={improvement.value}
                            className={css.option}
                            value={improvement.value}
                            label={improvement.label}
                            selected={selected === improvement.value}
                            onSelect={this.selectOption}
                        />
                    ))}
                </div>
            </div>
        );
    }
}

export default ImprovementTypePicker;



// WEBPACK FOOTER //
// ./components/improvement-type-picker/improvement-type-picker.js